// @core/api/endpoints/team/list_delegated_to_me.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListRoleDelegationsResponse,
} from '../../../types/team';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/team';

/**
 * List delegations assigned to me
 * Returns a paginated list of delegated to me. Supports filtering and sorting.
 */
export async function ListDelegatedToMe(
  team_id: string,
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListRoleDelegationsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:team_id/delegated-to-me`;
  requestPath = requestPath.replace(':team_id', encodeURIComponent(team_id));
  const requestOptions = options;
  return client.get<ListRoleDelegationsResponse>(requestPath, { ...requestOptions, params });
}
